<template>
  <svg
    class="filter-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="15.696"
    height="6.426"
    viewBox="0 0 15.696 6.426"
  >
    <g id="Group_544"
       data-name="Group 544"
       transform="translate(0.054 -2.574)"
    >
      <path
        id="Path_286"
        data-name="Path 286"
        d="M1.809-2.655l1.089-3h.018l1.071,3Zm.639-3.771L-.054,0H.819l.72-1.935H4.257L4.959,0H5.9L3.393-6.426ZM5.832-2.862v.72h4.5v-.72ZM10.53-.72V0h5.112V-.72h-4.1l3.987-4.986v-.72h-4.7v.72h3.69Z"
        transform="translate(0 9)"
        fill="#707070"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'FilterAz'
};
</script>
